﻿document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".sunglasses-type");
  const inputs = container.querySelectorAll('input[type="radio"]');
  const transitionList = document.querySelector(".transition-input-list");
  const groups = document.querySelectorAll(".sunglasses-type-input");
  const sunglassesInput = document.getElementById("extras-three");

  let originalImageSrc = null;
  let originalImageSrcset = null;
  let originalBackgroundImage = null;

  const mainImage = document.querySelector('.main-product-image img');
  if (mainImage) {
    originalImageSrc = mainImage.src;
    originalImageSrcset = mainImage.srcset;
    const lazyImageContainer = mainImage.closest('.lazy-image');
    if (lazyImageContainer) {
      originalBackgroundImage = lazyImageContainer.style.backgroundImage;
    }
  }

  function restoreOriginalImage() {
    const mainImage = document.querySelector('.main-product-image img');

    if (mainImage && originalImageSrc) {
      mainImage.src = originalImageSrc;
      mainImage.srcset = originalImageSrcset;
      
      const lazyImageContainer = mainImage.closest('.lazy-image');
      if (lazyImageContainer && originalBackgroundImage) {
        lazyImageContainer.style.backgroundImage = originalBackgroundImage;
      }
    }
  }

  if (sunglassesInput) {
    sunglassesInput.addEventListener('change', function() {
      if (!this.checked) {
        restoreOriginalImage();
      }
    });
  }

  const sliderButtons = document.querySelectorAll('.css-slider-button, .thumbnail');
  sliderButtons.forEach(button => {
    button.addEventListener('click', restoreOriginalImage);
  });

  inputs.forEach((input) => {
    input.addEventListener("change", function () {
      sunglassesInput.setAttribute("variant-id", input.getAttribute("variant-id"));
      const type = input.getAttribute("input-type");
      const sunglassesTypeInputs = document.querySelectorAll(".sunglasses-type-input");
      sunglassesTypeInputs.forEach((el) => {
        el.classList.add("hidden");
        if (el.getAttribute("input-type") === type) {
          el.classList.remove("hidden");
        }
      });

      if (window.sunglasses && window.sunglasses[input.id]) {
        const visibleContainer = Array.from(sunglassesTypeInputs).find(el => !el.classList.contains("hidden"));
        
        if (visibleContainer) {
          const containerInputs = visibleContainer.querySelectorAll('input[type="radio"]');
          const checkedInput = Array.from(containerInputs).find(inp => inp.checked);
          
          if (checkedInput) {
            const checkedIndex = Array.from(containerInputs).indexOf(checkedInput);
            const selectedImages = window.sunglasses[input.id];
            const imageKeys = Object.keys(selectedImages);
            
            if (imageKeys[checkedIndex]) {
              const imageUrl = selectedImages[imageKeys[checkedIndex]];
              
              const mainImage = document.querySelector('.main-product-image img');
              if (mainImage) {
                mainImage.src = imageUrl;
                mainImage.srcset = imageUrl;
                
                const lazyImageContainer = mainImage.closest('.lazy-image');
                if (lazyImageContainer) {
                  lazyImageContainer.style.backgroundImage = `url(${imageUrl})`;
                }
                
                if (window.innerWidth < 768) {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }
            }
          }
        }
      }
    });
  });

  const initial = Array.from(inputs).find((i) => i.checked);
  if (initial) {
    initial.dispatchEvent(new Event("change"));
  }

  groups.forEach((group) => {
    const inputs = group.querySelectorAll('input[type="radio"]');
    inputs.forEach((input) => {
      input.addEventListener("change", function () {
        if (!input.checked) return;
        sunglassesInput.setAttribute("variant-id", input.getAttribute("id"));
        const variantName = input.getAttribute("variant_name");
        const nameElement = group.querySelector(".variant-name");
        if (variantName && nameElement) {
          nameElement.innerHTML = "- " + variantName;
        }

        const selectedSunglassesType = document.querySelector('input[name="sunglasses-type"]:checked');
        if (selectedSunglassesType && window.sunglasses && window.sunglasses[selectedSunglassesType.id]) {
          const checkedIndex = Array.from(inputs).indexOf(input);
          const selectedImages = window.sunglasses[selectedSunglassesType.id];
          const imageKeys = Object.keys(selectedImages);
          
          if (imageKeys[checkedIndex]) {
            const imageUrl = selectedImages[imageKeys[checkedIndex]];
            const mainImage = document.querySelector('.main-product-image img');

            if (mainImage) {
              mainImage.src = imageUrl;
              mainImage.srcset = imageUrl;
              
              const lazyImageContainer = mainImage.closest('.lazy-image');
              if (lazyImageContainer) {
                lazyImageContainer.style.backgroundImage = `url(${imageUrl})`;
              }
              
              if (window.innerWidth < 768) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }
          }
        }
      });
    });
  });

  if (transitionList) {
    const transitionRadios = transitionList.querySelectorAll('input[type="radio"]');
    const nameElement = transitionList.querySelector(".variant-name");

    transitionRadios.forEach((input) => {
      input.addEventListener("change", function () {
        if (!input.checked) return;
        const variantName = input.getAttribute("variant_name");
        const nameElement = document.querySelector(".transition-type-variant-options .variant-name");
        if (variantName && nameElement) {
          nameElement.innerHTML = "- " + variantName;
        }
      });
    });
  }
});
